import "highcharts/modules/drilldown";

import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";

export const TolranceSalesViewItem = ({ data,isLoading }: any) => {
  const report = data?.res || data; // support both data and data.res

  
  if (!report || !report?.overWeightCategoriesJson?.length || !report.overWeightChartSeries?.length) {
    return !isLoading?(<div>No Data Found</div>):(<div>Loading chart...</div>);
  }

  // const options: Highcharts.Options = {
  //   chart: { type: "line" },
  //   title: { text: "Sales Over Weight" },
  //   xAxis: { categories: report.overWeightCategoriesJson, crosshair: true },
  //   yAxis: { min: 0, title: { text: "TAT (minutes)" } },
  //   tooltip: { shared: true, valueSuffix: " min" },
  //   plotOptions: { column: { borderRadius: 5, pointPadding: 0.2, groupPadding: 0.1 } },
  //   credits: { enabled: false },
  //   series:report.chartSeries || [] ,
  // };



  const options: Highcharts.Options = {
        chart: {type: 'line',},
        title: {  text: 'Over Weight Tolerance',},
        subtitle: {  useHTML: true, },
        xAxis: { categories:report.overWeightCategoriesJson || [] ,
        title: {  text: '',},
         type: 'datetime',
        },
        yAxis: {  title: { text: 'Over Weight Tolerance', }, labels: {
            formatter: function () {
              return `${this.value as string}`;
            }
          }},
           tooltip: {
          formatter: function () {
            return `<b></b> ${this.y} kg`;
          }
        },
       plotOptions: {
          line: {
            dataLabels: {
              enabled: true,
              formatter: function () {
                return this.y as number;
              }
            }
          }
        },
        credits: {
      enabled: false
    },
        series:report.overWeightChartSeries || [] ,
  };
  
return <HighchartsReact highcharts={Highcharts} options={options} />;
};
